import { stringEnum } from '@/models/type-generators/string-enum';

export type Circuit = 'DIRECT' | 'CROSSDOCK' | 'WAREHOUSE' | 'LDD';
export const Circuit = stringEnum<Circuit>();
